define(["require", "exports", "jquery", "./scrollWatcher", "./analytics", "./defer"], function (require, exports, $, scrollWatcher_1, analytics_1, defer_1) {
    "use strict";
    exports.__esModule = true;
    $(function () {
        $('.bottomless-paging a').click(function (e) {
            e.preventDefault();
        });
        var $pager = $('.bottomless-paging');
        var $container = $('.featured-product-grid > div');
        var selectItem = '.category-lead,.item-box';
        $pager.click(function (e) {
            fetchNextPage($pager, $container, selectItem);
        });
        scrollWatcher_1.hookScroll($pager, function () { return fetchNextPage($pager, $container, selectItem); });
    });
    function fetchNextPage($pager, $container, itemSelector) {
        var url = $pager.data('paging');
        analytics_1["default"]('home', 'fetchPage', url, 1, true);
        if ($pager.data('pending')) {
            return;
        }
        $pager.data('pending', true);
        $.get(url, null, function (html) {
            var $newPage = $(html);
            var nextUrl = $newPage.find('.bottomless-paging').data('paging');
            var $innerPage = $container;
            $innerPage.append(loadImageSrcImmediately($newPage).find(itemSelector));
            if (nextUrl) {
                $pager.data('paging', nextUrl);
                scrollWatcher_1.resetTrigger($pager);
            }
            else {
                $pager.remove();
            }
            $pager.data('pending', false);
        }, 'text');
    }
    function loadImageSrcImmediately($container) {
        var $imgs = $container.find('img[data-src]:not([data-src=""])');
        $imgs.each(function (i, img) {
            var $img = $(img);
            if (cdnEndpoint && requestSpecificCdnEndpoint && cdnEndpoint != requestSpecificCdnEndpoint) {
                var imgUrl = $img.data('src').replace(cdnEndpoint, requestSpecificCdnEndpoint);
                $img.attr('src', imgUrl);
                $img.data('src', imgUrl);
                if ($img.parent().attr('class') == 'cloud-zoom-gallery') {
                    var $imgContainer = $img.parent();
                    $imgContainer.attr('href', $imgContainer.attr('href').replace(cdnEndpoint, requestSpecificCdnEndpoint));
                    $imgContainer.attr('rel', $imgContainer.attr('rel').replace(cdnEndpoint, requestSpecificCdnEndpoint));
                    var $imgZoom = $imgContainer.parent().find('.img-zoom');
                    $imgZoom.attr('href', $imgZoom.attr('href').replace(cdnEndpoint, requestSpecificCdnEndpoint));
                    $imgContainer.CloudZoom();
                }
                if ($img.data('images')) {
                    var ImageUrls = $img.data('images').map(function (url) { return url.replace(cdnEndpoint, requestSpecificCdnEndpoint); });
                    $img.data('images', ImageUrls);
                }
            }
            else {
                $img.attr('src', $img.data('src')).removeData('src');
            }
        });
        return $container;
    }
    exports.loadImageSrcImmediately = loadImageSrcImmediately;
    function loadImageSrc($container, immediate) {
        if (immediate === void 0) { immediate = false; }
        if (!immediate) {
            defer_1["default"](function () { return loadImageSrcImmediately($container); }, 10);
        }
        else {
            loadImageSrcImmediately($container);
        }
        return $container;
    }
    exports.loadImageSrc = loadImageSrc;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/bottomLessScroll.js
// module id = 69
// module chunks = 0